import { useEffect } from 'react'
import { useAppStore } from '@/stores/appStore'
import { useAuth } from '@/stores/authStore'
import { useSidebarData } from '@/hooks/use-sidebar-data'
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarRail,
} from '@/components/ui/sidebar'
import { LanguageSwitcher } from '@/components/language-switcher'
import { NavGroup } from '@/components/layout/nav-group'
import { NavUser } from '@/components/layout/nav-user'
import { HeaderTenantSelector } from './header-tenant-selector'

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const auth = useAuth()
  const sidebarData = useSidebarData()
  const organization = useAppStore((state) => state.organization)

  // Create user object from auth data
  const user = {
    name: auth.user?.fullName || 'User',
    email: auth.user?.email || 'user@example.com',
    avatar: auth.user?.avatarUrl || '/avatars/shadcn.jpg',
  }

  useEffect(() => {
    if (!organization) return
    // set page title
    document.title = organization.name
  }, [organization])

  return (
    <Sidebar collapsible='icon' variant='floating' {...props}>
      <HeaderTenantSelector />
      {sidebarData?.isLoading ? (
        <SidebarContent className='min-h-0 flex-1'>
          <div className='flex h-full items-center justify-center'>
            <div className='h-10 w-10 animate-spin rounded-full border-2 border-gray-300 border-t-transparent' />
          </div>
        </SidebarContent>
      ) : (
        <SidebarContent className='min-h-0 flex-1 overflow-auto'>
          {sidebarData.navGroups.map((props) => (
            <NavGroup key={props.title} {...props} />
          ))}
        </SidebarContent>
      )}
      <SidebarFooter>
        <div className='flex flex-col gap-2'>
          <div className='px-2'>
            <LanguageSwitcher />
          </div>
          <NavUser user={user} />
        </div>
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
}
